import { useEffect, useState } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { get } from "../../utils/apiManager";

const InfoRow = ({ label, value }) => value !== undefined && value !== null && value !== '' ? (
  <div style={{ display: 'flex', padding: '10px 0', borderBottom: '1px solid #f0f2f8' }}>
    <div style={{ width: 180, flexShrink: 0, fontSize: 13, fontWeight: 600, color: '#9aa5c0' }}>{label}</div>
    <div style={{ fontSize: 14, color: '#0a1628', wordBreak: 'break-word', overflowWrap: 'anywhere', minWidth: 0, flex: 1 }}>{value}</div>
  </div>
) : null;

const pill = (active) => (
  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '3px 10px', borderRadius: 100, fontSize: 12, fontWeight: 700, background: active ? '#dcfce7' : '#fee2e2', color: active ? '#15803d' : '#b91c1c' }}>
    <span style={{ fontSize: 7 }}>●</span>{active ? 'Active' : 'Inactive'}
  </span>
);

const ViewOne = () => {
  const location = useLocation();
  const Navigate = useNavigate();
  const [plan, setPlan] = useState({});

  useEffect(() => {
    if (location?.search) getOnePlan(location.search.split("?")[1]);
  }, []);

  const getOnePlan = (id) => {
    get(`/pricing/${id}`)
      .then((res) => setPlan(res?.datas || {}))
      .catch((err) => console.log(err));
  };

  const feeLabels = { upfrontFee: 'Upfront Fee', monthlyFee: 'Monthly Fee', salesPercentage: 'Sales % Fee (of hammer)', parSalesPercentage: 'Flat Fee per Sale' };

  return (
    <div style={{ fontFamily: "'Segoe UI', system-ui, sans-serif" }}>
      <div style={{ background: '#fff', borderRadius: 14, border: '1px solid #edf0f7', boxShadow: '0 1px 4px rgba(26,39,68,.05)', overflow: 'hidden', maxWidth: 700 }}>
        <div style={{ padding: '18px 28px', borderBottom: '1px solid #edf0f7', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ fontSize: 16, fontWeight: 700, color: '#0a1628', margin: 0 }}>View Plan</h3>
          <button onClick={() => Navigate('/admin/pricing')} style={{ background: '#f0f2f8', color: '#5a6a8a', border: 'none', borderRadius: 8, padding: '8px 16px', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>← Back</button>
        </div>
        <div style={{ padding: '8px 28px 20px' }}>
          <InfoRow label="Plan Name" value={plan?.planName} />
          <InfoRow label="Description" value={plan?.description} />
          <InfoRow label="Period" value={plan?.period} />
          <div style={{ display: 'flex', padding: '10px 0', borderBottom: '1px solid #f0f2f8' }}>
            <div style={{ width: 180, flexShrink: 0, fontSize: 13, fontWeight: 600, color: '#9aa5c0' }}>Fee Types</div>
            <div>
              {plan?.fees?.length > 0
                ? plan.fees.map((fee, i) => (
                    <div key={i} style={{ fontSize: 14, color: '#0a1628', marginBottom: 2 }}>
                      {feeLabels[fee.type] || fee.type}: <strong>{fee.type === 'salesPercentage' ? `${fee.amount}%` : `$${fee.amount}`}</strong>
                    </div>
                  ))
                : <span style={{ fontSize: 14, color: '#9aa5c0' }}>{plan?.priceType || '—'}: {plan?.priceType === 'salesPercentage' ? `${plan?.amount}%` : `$${plan?.amount || 0}`}</span>
              }
            </div>
          </div>
          <InfoRow label="Auto-Renewal" value={plan?.period === 'Lifetime' ? 'One-time payment. No recurring billing.' : 'Auto-renews until cancelled.'} />
          {plan?.hasOwnProperty('isActive') && (
            <div style={{ display: 'flex', padding: '10px 0' }}>
              <div style={{ width: 180, flexShrink: 0, fontSize: 13, fontWeight: 600, color: '#9aa5c0' }}>Status</div>
              {pill(plan?.isActive)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewOne;
